export default "__VITE_ASSET__hBaq4DKD__"